export default "__VITE_ASSET__lQ7i7Hk9__"